import { render, staticRenderFns } from "./rank.vue?vue&type=template&id=d52051dc&scoped=true"
import script from "./rank.vue?vue&type=script&lang=js"
export * from "./rank.vue?vue&type=script&lang=js"
import style0 from "./rank.vue?vue&type=style&index=0&id=d52051dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52051dc",
  null
  
)

export default component.exports